import React from "react";
import "./FourOFour.scss";

export default function FourOFour() {
  return (
    <div id="FourOFour">
      <h3>You seem to have gotten lost!</h3>
      <button></button>
    </div>
  );
}
